import React from 'react';
import { UpcomingCustomInterview } from '../../api/roundsApi';
import InterviewExtractedInfoContent from './InterviewExtractedInfoContent';
import '../../styles/interview-detail-modal.css';

export type InterviewDetailModalSource = 'customise' | 'saved' | 'build-interview';

export interface InterviewDetailModalProps {
  interview: UpcomingCustomInterview | null;
  onClose: () => void;
  isCheckingResume: boolean;
  resumeExists: boolean;
  resumeMarkdown?: string;
  modalSource?: InterviewDetailModalSource;
  canCustomise?: boolean;
  customiseDisabledHint?: string;
  isCustomising: boolean;
  onCustomise: () => void;
  onViewResume: (markdown: string) => void;
}

const InterviewDetailModal: React.FC<InterviewDetailModalProps> = ({
  interview,
  onClose,
  isCheckingResume,
  resumeExists,
  resumeMarkdown,
  modalSource = 'customise',
  canCustomise = true,
  customiseDisabledHint,
  isCustomising,
  onCustomise,
  onViewResume,
}) => {
  if (!interview) return null;

  const handleViewResume = () => {
    if (resumeMarkdown) {
      onViewResume(resumeMarkdown);
    }
  };

  return (
    <div className="interview-detail-modal-overlay" onClick={onClose}>
      <div className="interview-detail-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="interview-detail-modal-close" onClick={onClose}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        <div className="interview-detail-modal-content">
          <div className="interview-detail-modal-scroll">
            <InterviewExtractedInfoContent interview={interview} />
          </div>
          <div className="interview-detail-modal-actions">
            {isCheckingResume ? (
              <button type="button" className="interview-detail-modal-btn" disabled>
                Checking...
              </button>
            ) : resumeExists ? (
              modalSource === 'saved' ? (
                <div className="interview-detail-modal-saved-footer">
                  <button
                    type="button"
                    className="interview-detail-view-btn"
                    onClick={handleViewResume}
                  >
                    View Resume
                  </button>
                </div>
              ) : (
                <div className="interview-detail-already-customised">
                  <p className="already-customised-message">
                    You have already customised a resume for this interview.
                  </p>
                  <button
                    type="button"
                    className="interview-detail-view-btn"
                    onClick={handleViewResume}
                  >
                    View Resume
                  </button>
                </div>
              )
            ) : !canCustomise ? (
              <div className="interview-detail-already-customised">
                <p className="already-customised-message">
                  {customiseDisabledHint ||
                    'Schedule the interview to customise your resume.'}
                </p>
                <button
                  type="button"
                  className="interview-detail-customise-btn"
                  disabled
                >
                  Customise Resume
                </button>
              </div>
            ) : (
              <div className="interview-detail-modal-action-row">
                {isCustomising && (
                  <span
                    className="interview-detail-modal-loader"
                    role="status"
                    aria-label="Customising resume"
                  />
                )}
                <button
                  type="button"
                  className="interview-detail-customise-btn"
                  onClick={onCustomise}
                  disabled={isCustomising}
                  aria-busy={isCustomising}
                >
                  Customise Resume
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewDetailModal;
